module.exports = __webpack_public_path__ + "static/img/about_h5bg_06_zh.0708ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_06_zh.png
// module id = BGtU
// module chunks = 34